import i18n from '@/helpers/i18n';

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('dashboard'),
        to: '/dashboard',
        icon: 'cil-speedometer',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('orders'),
        to: '/orders',
        icon: 'cil-money',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('products'),
        to: '/products/list',
        icon: 'cil-cart',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('experiences'),
        to: '/experiences/list',
        icon: 'cil-location-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('pois'),
        to: '/pois/list',
        icon: 'cil-location-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('members'),
        to: '/membros/lista',
        icon: 'cil-people',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('heros'),
        to: '/capa/lista',
        icon: 'cil-settings',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('keyValues'),
        to: '/informacoes/lista',
        icon: 'cil-settings',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('testimonials'),
        to: '/testimonials/list',
        icon: 'cil-people',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('profile'),
        to: '/profile',
        icon: 'cil-user',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('settings'),
        to: '/settings',
        icon: 'cil-settings',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: '/logout',
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]